module.exports = __webpack_public_path__ + "img/hcl-hero-new.e5cb78fb.png";